import script from "./VTableNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./VTableNumberInput.vue?vue&type=style&index=0&id=2bd2bfa4&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd2bfa4"]])

export default __exports__